import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "svg-icon-cpmFrontpageTypeShape",
  "use": "svg-icon-cpmFrontpageTypeShape-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"svg-icon-cpmFrontpageTypeShape\"><path d=\"M2 3v2h10.948l.648-.943L12.912 3H2zM0 1h14l2 3.09L14 7H0V1zm0 8h16v6H0V9z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol